/**
 * BillingAccountAPI
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateMerchantDto } from '../model/createMerchantDto';
import { Merchant } from '../model/merchant';
import { ModifyMerchantDto } from '../model/modifyMerchantDto';
import { ProblemDetails } from '../model/problemDetails';
import { ReadMerchantDto } from '../model/readMerchantDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MerchantService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMerchantCreateMerchantPost(body?: CreateMerchantDto, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiMerchantCreateMerchantPost(body?: CreateMerchantDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiMerchantCreateMerchantPost(body?: CreateMerchantDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiMerchantCreateMerchantPost(body?: CreateMerchantDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/Merchant/CreateMerchant`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param merchantId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMerchantDeleteMerchantDelete(merchantId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiMerchantDeleteMerchantDelete(merchantId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiMerchantDeleteMerchantDelete(merchantId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiMerchantDeleteMerchantDelete(merchantId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (merchantId !== undefined && merchantId !== null) {
            queryParameters = queryParameters.set('MerchantId', <any>merchantId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/Merchant/DeleteMerchant`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMerchantGetAllMerchantGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ReadMerchantDto>>;
    public apiMerchantGetAllMerchantGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReadMerchantDto>>>;
    public apiMerchantGetAllMerchantGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReadMerchantDto>>>;
    public apiMerchantGetAllMerchantGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReadMerchantDto>>('get',`${this.basePath}/api/Merchant/GetAllMerchant`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param authId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMerchantGetMerchantByAuthIdGet(authId?: string, observe?: 'body', reportProgress?: boolean): Observable<ReadMerchantDto>;
    public apiMerchantGetMerchantByAuthIdGet(authId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReadMerchantDto>>;
    public apiMerchantGetMerchantByAuthIdGet(authId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReadMerchantDto>>;
    public apiMerchantGetMerchantByAuthIdGet(authId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (authId !== undefined && authId !== null) {
            queryParameters = queryParameters.set('AuthId', <any>authId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ReadMerchantDto>('get',`${this.basePath}/api/Merchant/GetMerchantByAuthId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param merchantId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMerchantGetMerchantByMerchantIdGet(merchantId?: string, observe?: 'body', reportProgress?: boolean): Observable<ReadMerchantDto>;
    public apiMerchantGetMerchantByMerchantIdGet(merchantId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReadMerchantDto>>;
    public apiMerchantGetMerchantByMerchantIdGet(merchantId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReadMerchantDto>>;
    public apiMerchantGetMerchantByMerchantIdGet(merchantId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (merchantId !== undefined && merchantId !== null) {
            queryParameters = queryParameters.set('MerchantId', <any>merchantId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ReadMerchantDto>('get',`${this.basePath}/api/Merchant/GetMerchantByMerchantId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param billingEmail 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMerchantGetMerchantsByBillingEmailGet(billingEmail?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ReadMerchantDto>>;
    public apiMerchantGetMerchantsByBillingEmailGet(billingEmail?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReadMerchantDto>>>;
    public apiMerchantGetMerchantsByBillingEmailGet(billingEmail?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReadMerchantDto>>>;
    public apiMerchantGetMerchantsByBillingEmailGet(billingEmail?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (billingEmail !== undefined && billingEmail !== null) {
            queryParameters = queryParameters.set('BillingEmail', <any>billingEmail);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReadMerchantDto>>('get',`${this.basePath}/api/Merchant/GetMerchantsByBillingEmail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMerchantUpdateMerchantPut(body?: ModifyMerchantDto, observe?: 'body', reportProgress?: boolean): Observable<Merchant>;
    public apiMerchantUpdateMerchantPut(body?: ModifyMerchantDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Merchant>>;
    public apiMerchantUpdateMerchantPut(body?: ModifyMerchantDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Merchant>>;
    public apiMerchantUpdateMerchantPut(body?: ModifyMerchantDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Merchant>('put',`${this.basePath}/api/Merchant/UpdateMerchant`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
